import { Button } from "@/components/ui/button";

const ImportButton = ({ onImportDocx }) => (
  <label className="cursor-pointer">
    <input type="file" accept=".docx" onChange={onImportDocx} className="hidden" data-testid="import-docx-input" />
    <span className="inline-flex items-center bg-slate-700 hover:bg-slate-600 text-white font-semibold px-8 py-3 text-lg rounded-md transition-colors">
      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
      </svg>
      Import from Word
    </span>
  </label>
);

const AdminToolbar = ({ onNewArticle, onImportDocx, onViewArchived, onDeleteAllArticles, onViewSubscribers }) => (
  <div className="flex flex-wrap justify-center gap-4 mb-12">
    <Button data-testid="new-article-button" onClick={onNewArticle} className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 text-lg">
      + New Article
    </Button>
    <ImportButton onImportDocx={onImportDocx} />
    <Button data-testid="view-subscribers-button" onClick={onViewSubscribers} variant="outline" className="border-blue-600 text-blue-400 hover:bg-blue-900/30 font-semibold px-6 py-3">
      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
      Subscribers
    </Button>
    <Button data-testid="view-archived-button" onClick={onViewArchived} variant="outline" className="border-yellow-600 text-yellow-400 hover:bg-yellow-900/30 font-semibold px-6 py-3">
      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8" /></svg>
      Archived Articles
    </Button>
    <Button data-testid="delete-all-articles-button" onClick={onDeleteAllArticles} variant="outline" className="border-red-600 text-red-400 hover:bg-red-900/30 font-semibold px-6 py-3">
      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
      Delete All Articles
    </Button>
  </div>
);

export default AdminToolbar;
